import { Draft } from '@reduxjs/toolkit';

import { IProductData } from '../../index';

function checkImportSpreadsheetSuccess(draft: Draft<IProductData>) {
  draft.importSpreadsheet.id = null;
}

export default checkImportSpreadsheetSuccess;
